<template>
  <Dropdown
    position="right"
    class="header-menu-user"
    buttonClass="header-menu-user__toggle"
    :auto-close="false"
    :is-visible="this.isVisible"
    @toggle="handleToggleAvatar"
  >
    <Avatar :title="initials" :src="$auth.user.avatarUrl" clickable type="next-small" />
    <ClientOnly>
      <HeaderReferralTooltip />
    </ClientOnly>
    <DropdownMenu slot="menu" class="header-menu-user__dropdown-menu">
      <div class="header-menu-user__items" @click="handleClose" @keydown.esc="handleClose">
        <div class="header-menu-user__menu">
          <HeaderMenuItem :link="link" menu="Portfolio">My Portfolio</HeaderMenuItem>
          <HeaderMenuItem link="/profile/settings" menu="Settings">Settings</HeaderMenuItem>
          <HeaderMenuItem
            v-if="!$auth.user.hasInstalledMobileApp"
            :link="linkToMobileApp"
            external
            target="_blank"
            rel="nofollow noopener noreferrer"
            menu="MobileApp"
          >
            Get Bravado App
          </HeaderMenuItem>
          <HeaderMenuItem menu="SignOut" @click.native="handleSignOut">Sign Out</HeaderMenuItem>
        </div>
        <ClientOnly>
          <HeaderAnonymousProfile />
        </ClientOnly>
      </div>
      <ClientOnly>
        <HeaderReferralSection />
      </ClientOnly>
    </DropdownMenu>
  </Dropdown>
</template>

<script>
import { mapActions } from 'vuex';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import Dropdown, { DropdownMenu } from '@/components/common/Dropdown';
import HeaderReferralSection from '@/components/global/HeaderMenu/HeaderReferral/HeaderReferralSection/HeaderReferralSection.vue';

import { getPortfolioPath } from '@/utils/routes';
import HeaderMenuItem from './HeaderMenuItem.vue';
import { LINK_TO_MOBILE_APP } from '~/constants/common';

export default {
  name: 'HeaderMenuUser',
  components: {
    Avatar,
    Dropdown,
    DropdownMenu,
    HeaderMenuItem,
    HeaderReferralSection,
    HeaderReferralTooltip: () =>
      import('@/components/global/HeaderMenu/HeaderReferral/HeaderReferralTooltip/HeaderReferralTooltip.vue'),
    HeaderAnonymousProfile: () =>
      import('@/components/global/HeaderMenu/HeaderAnonymousProfile/HeaderAnonymousProfile.vue'),
  },
  data() {
    return {
      isVisible: false,
    };
  },
  computed: {
    linkToMobileApp() {
      return LINK_TO_MOBILE_APP;
    },
    initials() {
      return this.$auth.user.initials;
    },
    link() {
      return getPortfolioPath(this.$auth.user.slug);
    },
  },
  methods: {
    ...mapActions(['signOut']),
    async handleSignOut() {
      try {
        await this.signOut();
      } catch (e) {
        this.$notice.error(e);
      }
    },
    handleToggleAvatar(show = false) {
      this.isVisible = show;
      this.$store.commit('ui/toggleReferralTooltip', false);
      this.$analytics.logEvent(`global__header-nav__avatar__click`, { show });
    },
    handleClose() {
      this.isVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.header-menu-user {
  &__dropdown-menu {
    min-width: 312px;
    margin-top: 8px;
    background-color: var(--theme-color-background);
  }

  &__items {
    padding: 16px 20px;
    background-color: var(--theme-color-card);
  }

  &__menu {
    overflow: hidden;
    border-radius: 8px;
    margin-bottom: 16px;
  }

  ::v-deep &__toggle {
    border-radius: 50%;
  }
}
</style>
